import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import DashboardLayout from "./components/dashboard/DashboardLayout";
import reportWebVitals from "./reportWebVitals";
import Register from "./components/register";
import Login from "./components/login";
import Home from "./components/home";
import Withdraw from "./components/dashboard/withdraw";
import Withdraw2 from "./components/dashboard/withdraw2";
import ChangeWalletOwner from "./components/dashboard/ChangeWalletOwner";
import ChangeWallet from "./components/dashboard/ChangeWallet";
import UpgradeContractFunds from "./components/dashboard/UpgradeContractFunds";
import PoolFunds from "./components/dashboard/PoolFunds";
import ChangeClaimPeriod from "./components/dashboard/ChangeClaimPeriod";
import ChangeWalletByOwner from "./components/dashboard/ChangeWalletByOwner";
import ChangeWalletMarketing from "./components/dashboard/ChangeWalletMarketing";

import { createWeb3Modal, defaultWagmiConfig } from '@web3modal/wagmi/react'
import { WagmiConfig } from 'wagmi'
import { polygon, bscTestnet } from 'viem/chains'

// 1. Get projectId at https://cloud.walletconnect.com
const projectId = 'a09d5c2c543e56f82035045839d7499f' 
// const projectId = 'ae64d2d938316ce3350fea4c10f6cc79'


// 2. Create wagmiConfig
const metadata = {
  name: 'IP Matrix',
  description: 'IP Matrix',
  url: 'https://ip2025.biz/',
  icons: ['https://avatars.githubusercontent.com/u/37784886']
}
const chains = [polygon]
const wagmiConfig = defaultWagmiConfig({ chains, projectId, metadata })

// 3. Create modal
createWeb3Modal({ wagmiConfig, projectId, chains })


const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <WagmiConfig config={wagmiConfig}>
      <BrowserRouter>
        <Routes>
          <Route path="" element={<Home />} />
          {/* <Route path="register" element={<Register />} />
          <Route path="login" element={<Login />} /> */}
          <Route path="withdraw" element={<Withdraw />} />
          <Route path="marketing" element={<Withdraw2 />} />
          {/* <Route path="butterflyeffect2023y" element={<ChangeWallet />} /> */}
          {/* <Route path="ChangeClaimPeriod" element={<ChangeClaimPeriod />} /> */}
          <Route path="wchangebyboss" element={<ChangeWalletByOwner />} />
          <Route path="wchange" element={<ChangeWallet />} />
          <Route path="ugfunds" element={<UpgradeContractFunds />} />
          <Route path="asfunds" element={<PoolFunds />} />
          <Route path="ochange" element={<ChangeWalletOwner />} />
          <Route path="mchange" element={<ChangeWalletMarketing />} />
          <Route path="*" element={<DashboardLayout />} />
        </Routes>
      </BrowserRouter>
    </WagmiConfig>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
